export default [
    {
        path: '/owners/us-open-2026/:listingId(\\d+)?/addendum/:hash',

        components: {
            default: () => import(/* webpackChunkName: "owners.vendors" */ '@/views/Owners/Events/UsOpen2026.vue'),
            mainMenu: () => import(/* webpackChunkName: "main.menu.blank" */ '@/menus/Main/Blank.vue'),
        },
        meta: {
            group: '/owners/events/us-open-2026',
            label: 'Championship Week at Shinnecock Hills 2026',
            multiRoute: 'owners.events.usopen2026',
            authRequired: false,
        }
    },
];
